import { getImagePath } from "../Utils/Utilities";

export const productFeatures = [
    {
      id: "crm",
      title: "CRM",
      img: "/Images/Icons/Leads.png",
      tagline: "Convert more Inquiries to Sales!",
      items: [
          "Import from IndiaMART, TradeIndia, JustDial, Meta (FB), 99acres, MagicBricks",
          "Assign Leads to Team",
          "Monitor Interactions & Appointments",
          "Monitor Visits and Travel History Logs",
          "Track Prospects in Stages of Conversion",
          "Analyze Performance & Rejections",
        ],
      screens: [
        {
          sTitle: "Lead Integrations",
          sPic: getImagePath("/Images/Features/LeadIntegrations.png"),
        },
        {
          sTitle: "Lead Management",
          sPic: getImagePath("/Images/Features/LeadMgmt.png"),
        },
        {
          sTitle: "Interactions & Appointments",
          sPic: getImagePath("/Images/Features/LeadProspInxnsNew.png"),
        },
        {
          sTitle: "Travel History Log",
          sPic: getImagePath("/Images/Features/LeadProspTravelHistory.png"),
        },
        {
          sTitle: "Prospect Funnel",
          sPic: getImagePath("/Images/Features/LeadProspFunnel.png"),
        },
        {
          sTitle: "Analysis using Leads Dashboard",
          sPic: getImagePath("/Images/Features/LeadDashboard.png"),
        }
      ],
      faqs: [
        { q: "Can I import leads from Excel or other lead platforms?", a: "Yes. You can import leads using our Excel template or directly import them from platforms like <b>IndiaMART, TradeIndia, JustDial, Meta Forms, 99Acres, MagicBricks</b>, or through your <b>website API.</b>" },
        { q: "Can I reassign leads to another team member?", a: "Yes. Simply open the lead, click <b>Reassign</b>, and select the executive you want to assign it to." },
        { q: "Can I convert a lead into a customer and still keep it as a lead?", a: "Yes. When converting a lead into a customer, the system asks if you want to <b>keep the lead record as a lead as well.</b>" },
        { q: "Can I add extra fields in lead details?", a: "Yes. In QikERP, you can add <b>custom fields</b> in lead details to store information according to your business needs." },
      ],
    },
    {
      id: "quotations",
      title: "Quotations",
      img: "/Images/Icons/Quotations.png",
      tagline: "Impress customer to seal the deal!",
      items: [
        "Create Quotations & Proforma Invoices",
        "Share via WhatsApp Web or Email",
        "Manage Templates and Revisions",
        "Add Product Images",
        "Customize Document Series",
      ],
      screens: [
        {
          sTitle: "Manage Quotes & Proforma Invoices",
          sPic: getImagePath("/Images/Features/QuoteList.png"),
        },
        {
          sTitle: "Share via WhatsApp, Email",
          sPic: getImagePath("/Images/Features/QuoteShare.png"),
        },
        {
          sTitle: "Quote Print Sample",
          sPic: getImagePath("/Images/Features/QuotePrint.png"),
        },
        {
          sTitle: "Product Image in Quotation",
          sPic: getImagePath("/Images/Features/QuotePrint.png"),
        },
        {
          sTitle: "Customize Document Series",
          sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
        },
      ],
      faqs: [
        { q: "Can I create quotations with product images?", a: "Yes. You can add product images in quotations to <b>present your products more clearly to customers.</b>" },
        { q: "Can I customize the quotation format according to my business?", a: "Yes. You can adjust <b>print settings</b> and choose what information appears in the quotation so <b>it matches your business needs.</b>" },
        { q: "Can I add extra columns or fields in quotations?", a: "Yes. You can add <b>up to 5 additional columns or fields</b> in quotations to <b>capture extra details required for your business.</b>" },
        { q: "Can I send quotations directly from QikERP?", a: "Yes. You can send quotations directly to customers via <b>Email or WhatsApp</b>, making it <b>faster to share quotes and close deals.</b>" },
      ],
    },
    {
      id: "sales-orders",
      title: "Orders",
      img: "/Images/Icons/Orders.png",
      tagline: "Delight customers, win repeat business!",
      items: [
        "Manage Sales Orders",
        "Send Smart Acknowledgement",
        "Give Status Updates",
        "Get Feedback & Google Rating",
        "Customize Document Series",
        "Monitor through Reports",
      ],
      screens: [
        {
          sTitle: "Manage Sales Orders",
          sPic: getImagePath("/Images/Features/InvoiceList.png"),
        },
        {
          sTitle: "Share via WhatsApp, Email",
          sPic: getImagePath("/Images/Features/InvoiceShare.png"),
        },
        {
          sTitle: "Give Status Updates",
          sPic: getImagePath("/Images/Features/OrdStatusUpdate.png"),
        },
        {
          sTitle: "Get Feedback",
          sPic: getImagePath("/Images/Features/OrdFeedback.png"),
        },
        {
          sTitle: "Customize Document Series",
          sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
        },
        {
          sTitle: "Monitor through Reports",
          sPic: getImagePath("/Images/Features/InvoiceReports.png"),
        }
      ],
      faqs: [
        { q: "Can I create sales orders in QikERP?", a: "Yes. You can easily create and manage sales orders in QikERP." },
        { q: "Can I track order status?", a: "Yes. You can track order status and also create custom stages according to your business process." },
        { q: "Can I convert a quotation into an order?", a: "Yes. You can easily convert a quotation into a sales order in QikERP." },
        { q: "Can I create an order directly from an invoice?", a: "Yes. QikERP allows you to create an order directly from an invoice if required." },
        { q: "Can I see all pending and completed orders?", a: "Yes. You can view all pending and completed orders, along with delay logs to understand why orders were delayed." },
        { q: "Can multiple team members manage orders?", a: "Each order has one primary person responsible, but other team members can view or update it if they are given the required permissions." },
        { q: "Can I notify customers when the order status changes?", a: "Yes. You can notify customers via <b>Email or WhatsApp</b> when the order status is updated." },
      ],
    },
    {
      id: "billing",
      title: "Billing",
      img: "/Images/Icons/Billing.png",
      tagline: "Simplify, Comply, Enjoy!",
      items: [
        "Customize Invoice Print",
        "Generate GST Invoices",
        "Generate E-way Bills",
        "Customize Document Series",
        "Send via WhatsApp Web or Email",
        "Analyze Trade Profitability",
        "GST Compliance (GSTR-1 & 3B JSONs)",
        "Manage E-Invoice",
      ],
      screens: [
        {
          sTitle: "Customize Invoice Print",
          sPic: getImagePath("/Images/Features/PrintHeader.png"),
        },
        {
          sTitle: "Create Party Invoices",
          sPic: getImagePath("/Images/Features/InvoiceEntryB2B.png"),
        },
        {
          sTitle: "Generate E-way Bills",
          sPic: getImagePath("/Images/Features/InvoiceEway.png"),
        },
        {
          sTitle: "Customize Auto Document Series",
          sPic: getImagePath("/Images/Features/InvoiceDocSeries.png"),
        },
        {
          sTitle: "Share via WhatsApp, Email",
          sPic: getImagePath("/Images/Features/InvoiceShare.png"),
        },
        {
          sTitle: "Analyze Trade Profitability",
          sPic: getImagePath("/Images/Features/InvoiceRptTradeProfitability.png"),
        },
        {
          sTitle: "GST Compliance (GSTR-1 & 3B JSONs)",
          sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
        },
        {
          sTitle: "Invoice Print Sample (E-Invoice)",
          sPic: getImagePath("/Images/Features/InvoicePrintEInvoice.png"),
        },
      ],
      faqs: [
        { q: "Can I create a dispatch from an invoice in QikERP?", a: "Yes. You can create a dispatch directly from the invoice inside QikERP, making order fulfillment quick and simple." },
        { q: "Can I generate E-Way Bills from QikERP?", a: "Yes. Simply connect your GST account with QikERP and generate <b>E-Way Bills directly from the system.</b>" },
        { q: "Can I analyze my sales performance?", a: "Yes. QikERP provides detailed sales reports like Daily & Monthly Sales Analysis, Trade Profitability, Customer Repeat Business, Feedback Analysis, and Sales Team Performance. These reports help you understand trends, track performance, and make better business decisions." },
        { q: "Can I edit an invoice after creating it?", a: "Yes. You can edit an invoice and update details whenever required." },
        { q: "Can I add discounts or extra charges in an invoice?", a: "Yes. You can add <b>discounts</b> as well as <b>additional charges</b> in invoices as needed." },
      ],
    },
    {
      id: "recovery",
      title: "Recovery",
      img: "/Images/Icons/Payment Recovery.png",
      tagline: "Collect smartly & quickly!",
      items: [
        "Track Bill-wise Receivables",
        "Send Follow-up Reminders",
        "Link to RazorPay Gateway",
        "Send Thank You Note on Receipt",
      ],
      screens: [
        {
          sTitle: "Track Receivables & Outstanding",
          sPic: getImagePath("/Images/Features/InvoiceList.png"),
        },
        {
          sTitle: "Share Payment Reminders via WhatsApp",
          sPic: getImagePath("/Images/Features/InvoiceShare.png"),
        },
        {
          sTitle: "Offer Easy Payment Options",
          sPic: getImagePath("/Images/Features/InvoiceTP.png"),
        },
        {
          sTitle: "Send Thank You note",
          sPic: getImagePath("/Images/Features/ThankYouNote.png"),
        },
      ],
      faqs: [
        { q: "Can I track pending payments from customers?", a: "Yes. The Recovery module shows all pending receivables in one place so you can <b>monitor outstanding payments easily.</b> " },
        { q: "Can I send payment reminders to customers?", a: "Yes. You can send reminders through <b>Email or WhatsApp</b>, helping you <b>follow up faster and improve payment collection.</b>" },
        { q: "Can I update receivable amounts after receiving payment?", a: "Yes. You can update amounts when full or partial payment is received so your <b>records always stay accurate.</b> " },
        { q: "Can I see all pending payments in one place?", a: "Yes. The Recovery list shows all pending receivables with customer details so you can <b>quickly identify who still needs to pay.</b>" },
      ],
    },
    {
      id: "accounts",
      title: "Accounts",
      img: "/Images/Icons/Accounts.png",
      tagline: "Monitor from your Mobile!",
      items: [
        "Access Real-time Accounts from Your Mobile",
        "Track Key Ledgers Easily",
        "Enter Vouchers Easily",
        "Get Balance Sheet, P&L, etc.",
        "Generate GSTR-1 & 3B JSON",
        "Manage Multiple Branches",
      ],
      screens: [
        {
          sTitle: "Access Real-time Accounts from your Mobile",
          sPic: getImagePath("/Images/Features/AccountsDsbdMob.png"),
        },
        {
          sTitle: "CEO-friendly Easy Accounting",
          sPic: getImagePath("/Images/Features/AccountsDsbd.png"),
        },
        {
          sTitle: "Enter Vouchers Easily",
          sPic: getImagePath("/Images/Features/AccountsVoucherEntry.png"),
        },
        {
          sTitle: "Access Live Statements",
          sPic: getImagePath("/Images/Features/AccountsStatements.png"),
        },
        {
          sTitle: "Simplify GST Compliance",
          sPic: getImagePath("/Images/Features/InvoiceGSTR3B.png"),
        },
        {
          sTitle: "Manage Multiple Branches",
          sPic: getImagePath("/Images/Features/AccountsMultiBranch.png"),
        },
      ],
      faqs: [
        { q: "Can I enter accounting vouchers?", a: "Yes. You can record vouchers directly, making it easy to update accounts anytime." },
        { q: "Can I track important ledgers easily?", a: "Yes. QikERP lets you track key ledgers and monitor balances whenever required." },
        { q: "Can I see financial reports like Balance Sheet and Profit & Loss?", a: "Yes. You can generate reports like <b>Balance Sheet, Profit & Loss, and other financial summaries</b> to understand your business performance." },
        { q: "Can I generate GST reports like GSTR-1 and GSTR-3B?", a: "Yes. QikERP allows you to generate <b>GSTR-1 and GSTR-3B JSON</b> files for GST filing." },
        { q: "Can I import my existing ledgers from Excel?", a: "Yes. You can easily import ledgers using an Excel template to set up your accounts quickly." },
        { q: "Can I export accounting data to Tally?", a: "Yes. You can export accounting data from QikERP and use it in <b>Tally</b> when needed." },
        { q: "Can I create Credit Notes and Debit Notes?", a: "Yes. You can create <b>Credit Notes and Debit Notes</b> to manage returns, adjustments, or corrections in transactions." },
      ],
    },
    {
      id: "purchase",
      title: "Purchase",
      img: "/Images/Icons/Purchase.png",
      tagline: "Get more from your Suppliers!",
      items: [
        "Generate Purchase Orders",
        "Manage Supplier Invoices",
        "Plan based on Inventory Shortfall"
      ],
      screens: [
        {
          sTitle: "Generate Purchase Order",
          sPic: getImagePath("/Images/Features/PurchaseOrder.png"),
        },
        {
          sTitle: "Manage Supplier Invoice",
          sPic: getImagePath("/Images/Features/SupplierInvoice.png"),
        },
        {
          sTitle: "Observe Items with Insufficient Stock",
          sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
        },
      ],
      faqs: [
        { q: "Can I record materials received from suppliers?", a: "Yes. You can create <b>Purchase Inward (GRN)</b> entries to record materials received into inventory." },
        { q: "Can I create purchase orders before buying from suppliers?", a: "Yes. You can create and manage <b>Purchase Orders (PO)</b> to place orders with suppliers." },
        { q: "Can I edit purchase orders or supplier invoices later?", a: "Yes. You can edit and update purchase orders or supplier invoices whenever required." },
        { q: "Can I add extra fields in purchase orders?", a: "Yes. You can add additional columns or fields in purchase orders according to your business needs." },
        { q: "Can I send reminders to suppliers for purchase orders?", a: "Yes. You can send reminders to suppliers via <b>Email or WhatsApp</b> directly from the purchase order." },
        { q: "Can I analyze purchase and trade profitability?", a: "Yes. QikERP provides reports to compare <b>purchases vs sales</b> and analyze profitability." },
      ],
    },
    {
      id: "inventory",
      title: "Inventory",
      img: "/Images/Icons/Inventory.png",
      tagline: "Stock smartly!",
      items: [
        "Track Inventory Stock",
        "Manage Stock at Multiple Stores",
        "Observe Items with Insufficient Stock",
        "Easy Item Entry",
        "Log Batches & Expiry Dates",
        "Manage BOM (Bill of Materials)",
        "Track Inventory Transactions",
        "Monitor through Reports"
      ],
      screens: [
        {
          sTitle: "Track Inventory Stock",
          sPic: getImagePath("/Images/Features/InventoryStockList.png"),
        },
        {
          sTitle: "Manage Stock at Multiple Stores",
          sPic: getImagePath("/Images/Features/InventoryStores.png"),
        },
        {
          sTitle: "Observe Items with Insufficient Stock",
          sPic: getImagePath("/Images/Features/InventoryInsufficient.png"),
        },
        {
          sTitle: "Easy Item Entry",
          sPic: getImagePath("/Images/Features/InventoryItemEntry.png"),
        },
        {
          sTitle: "Log Batches & Expiry Dates",
          sPic: getImagePath("/Images/Features/InventoryItemBatches.png"),
        },
        {
          sTitle: "Manage BOM (Bill of Materials)",
          sPic: getImagePath("/Images/Features/InventoryBOM.png"),
        },
        {
          sTitle: "Track Inventory Transactions",
          sPic: getImagePath("/Images/Features/InventoryXnTypes.png"),
        },
        {
          sTitle: "Monitor through Reports",
          sPic: getImagePath("/Images/Features/InventoryReports.png"),
        },
      ],
      faqs: [
  { q: "Can I manage multiple stores or warehouses?", a: "Yes. QikERP allows you to manage multiple stores or warehouses within the system." },
  { q: "Can I manage both raw materials and finished products?", a: "Yes. You can manage <b>raw materials, finished goods, spares, and assemblies in inventory.</b>" },
  { q: "Can I increase stock when items are received?", a: "Yes. You can increase stock when items are received from purchases or production." },
  { q: "Can I reduce stock when items are issued or dispatched?", a: "Yes. Stock automatically reduces when items are <b>dispatched or issued for production.</b>" },
  { q: "Can I track all stock movements?", a: "Yes. You can track <b>stock inward, dispatch, issues, and all inventory transactions through inventory reports.</b>" },
  { q: "Can I import inventory items using Excel?", a: "Yes. You can quickly import inventory items using an <b>Excel template instead of adding them manually.</b>" }
]
    },
    {
      id: "manufacturing",
      title: "Production",
      img: "/Images/Icons/Manufacturing.png",
      tagline: "Make (smartly) in India!",
      items: [
        "Launch Production Jobs",
        "Track WIP at Process Stages",
        "Monitor Material Consumption vs BOM",
        "Analyze Rejection Reasons",
        "Track Job Status against Plan",
        "Print Manufacturing Job Card"
      ],
      screens: [
        {
          sTitle: "Easy Production Job Entry",
          sPic: getImagePath("/Images/Features/ProductionJobEntry.png"),
        },
        {
          sTitle: "Monitor Manufacturing (WIP) Jobs",
          sPic: getImagePath("/Images/Features/ProductionList.png"),
        },
        {
          sTitle: "Track Job Status, Monitor Issued Materials",
          sPic: getImagePath("/Images/Features/ProductionJobDetails.png"),
        },
        {
          sTitle: "Monitor through Reports",
          sPic: getImagePath("/Images/Features/ProductionReports.png"),
        },
        {
          sTitle: "Track Job Status against Plan",
          sPic: getImagePath("/Images/Features/ProductionJobTracking.png"),
        },
        {
          sTitle: "Manufacturing Job Card Print Sample",
          sPic: getImagePath("/Images/Features/ProductionJobCard.png"),
        }
      ],
      faqs: [
        { q: "Can I define my own production stages and process flow?", a: "Yes. You can create and manage your own production stages and workflows according to your manufacturing process." },
        { q: "Can different products have different production stages?", a: "Yes. You can set different production stages and process flows for different products." },
        { q: "Can I add or reject items during production?", a: "Yes. You can add more items or reject items even after the production job has been created." },
        { q: "Can I analyze my production with reports?", a: "Yes. QikERP provides multiple production reports such as <b>Consumption Analysis, Rejection Cause Analysis, Production History, Product-wise Manufacturing Analysis, Production Job Analysis, Completion Punctuality, and Production Output</b>." },
      ],
    },
    {
      id: "support",
      title: "Support",
      img: "/Images/Icons/Support Ticketing.png",
      tagline: "Quicken Customer Care!",
      items: [
        "Enter & Acknowledge Support Tickets",
        "Track for Timely Completion",
        "Request Feedback on Satisfaction"
      ],
      screens: [
        {
          sTitle: "Support Tickets Management",
          sPic: getImagePath("/Images/Features/Support.png"),
        },
        {
          sTitle: "Track Status",
          sPic: getImagePath("/Images/Features/SupportDue.png"),
        },
        {
          sTitle: "Support Feedback",
          sPic: getImagePath("/Images/Features/SupportFeedback.png"),
        },
      ],
      faqs: [
        { q: "Can I create support tickets for customer issues?", a: "Yes. You can create support tickets and track them with a due date." },
        { q: "Can I track the status of support tickets?", a: "Yes. You can track ticket status such as <b>Work in Progress (WIP) or Done</b>." },
        { q: "Can I assign tickets to team members?", a: "Yes. You can assign support tickets to different team members." },
        { q: "Can I add comments or updates on a ticket?", a: "Yes. You can add notes inside the support ticket." },
        { q: "Can I notify customers about ticket status updates?", a: "Yes. You can send ticket status updates and request feedback from customers via <b>Email or WhatsApp</b>." },
      ],
    },
    {
      id: "contracts",
      title: "Contracts",
      img: "/Images/Icons/Contracts.png",
      tagline: "Renew in time!",
      items: [
        "Enter Contracts Easily",
        "Track Contracts & Subscriptions",
        "Attach Contract File"
      ],
      screens: [
        {
          sTitle: "Enter Contracts Easily",
          sPic: getImagePath("/Images/Features/ContractEntry.png"),
        },
        {
          sTitle: "Track Contracts & Subscriptions",
          sPic: getImagePath("/Images/Features/ContractManage.png"),
        },
        {
          sTitle: "Attach Contract File",
          sPic: getImagePath("/Images/Features/ContractEntry.png"),
        },
      ],
      faqs: [
        { q: "Can I set contract start and end dates?", a: "Yes. You can define start and end dates for contracts and track them accordingly." },
        { q: "Can I track active and expired contracts?", a: "Yes. You can view active and inactive contracts and also filter contracts due for renewal <b>this month, next month, or within the next 12 months</b>." },
        { q: "Can I attach documents or agreement files to contracts?", a: "Yes. You can attach agreement documents directly to the contract for easy reference." },
        { q: "Can I manage AMC (Annual Maintenance Contracts)?", a: "Yes. You can manage <b>AMC contracts</b>, track their duration, and monitor renewals." },
        { q: "Can I set different renewal rates from the contract charges?", a: "Yes. You can define renewal charges separately from the original contract charges." },
      ],
    },
    {
      id: "tasks",
      title: "Tasks",
      img: "/Images/Icons/Tasks.png",
      tagline: "Stay Organized!",
      items: [
        "Finish own tasks (Inbox)",
        "Monitor delegated tasks (Outbox)",
        "Log completed/paused tasks"
      ],
      screens: [
        {
          sTitle: "Manage Own Tasks in Inbox",
          sPic: getImagePath("/Images/Features/TasksDesktop.png"),
        },
        {
          sTitle: "Track Delegated Tasks in Outbox",
          sPic: getImagePath("/Images/Features/TaskOutbox.png"),
        },
        {
          sTitle: "Log Tasks",
          sPic: getImagePath("/Images/Features/TaskPause.png"),
        },
      ],
      faqs: [
        { q: "Can I assign tasks to team members?", a: "Yes. You can assign tasks to specific team members and track their progress." },
        { q: "Can I set deadlines for tasks?", a: "Yes. You can define due dates for tasks to ensure work is completed on time." },
        { q: "Can I track the status of tasks?", a: "Yes. You can update and track task status such as <b>Pending, Work in Progress, or Completed</b>." },
        { q: "Can I add notes or updates to a task?", a: "Yes. You can add <b>details and updates</b> within the task to keep everyone informed." },
        { q: "Can I set priority for tasks?", a: "Yes. You can set task priorities such as <b>High, Medium, or Normal</b> to manage work more effectively." },
        { q: "Can I send reminders to team members for their tasks?", a: "Yes. You can easily send task reminders to your team members to ensure work is completed on time." },     
      ],
    },
  ];